var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"page-title mb-1"},[_vm._v(" "+_vm._s(this.$route.meta.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }